var React = require('react');

function ProjectError (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#B94A48","fillRule":"evenodd","d":"M6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 Z M6,8.25 C5.58578644,8.25 5.25,8.58578644 5.25,9 C5.25,9.41421356 5.58578644,9.75 6,9.75 C6.41421356,9.75 6.75,9.41421356 6.75,9 C6.75,8.58578644 6.41421356,8.25 6,8.25 Z M6,2.25 C5.62030423,2.25 5.30650904,2.53215388 5.25684662,2.89822944 L5.25,3 L5.25,6.75 C5.25,7.16421356 5.58578644,7.5 6,7.5 C6.37969577,7.5 6.69349096,7.21784612 6.74315338,6.85177056 L6.75,6.75 L6.75,3 C6.75,2.58578644 6.41421356,2.25 6,2.25 Z"}));
}

ProjectError.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = ProjectError;

ProjectError.default = ProjectError;
